import { useTranslation } from "react-i18next";
import { Control, Controller } from "react-hook-form";
import { FormControl, FormLabel, TextField, Autocomplete, FormHelperText } from "@mui/material";

import { useProfileData } from "../../../../hooks/useProfileData";

import { useEntityAchievements } from "../../../Entity/api/queries/useEntityAchievements";

import { CreatePostFormData } from "../../api/types/feed.types";
import { CreatePostAutocompleteIcon } from "../../assets/icons/create-feed";
import { commonStyles } from "../../pages/CreatePostPage/components/CreatePostForm/index";

interface AchievementsFieldProps {
  control: Control<CreatePostFormData>;
  name: "achievementId";
  error?: string;
}

export const AchievementsField = ({ control, name, error }: AchievementsFieldProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "postForm" });
  const { data: userData } = useProfileData();
  const { data: achievements } = useEntityAchievements(userData?.entityId?.toString() || null);

  const achievementsList = achievements ? Object.values(achievements) : [];

  return (
    <FormControl fullWidth component="fieldset" sx={commonStyles.formControl} error={!!error}>
      <FormLabel sx={commonStyles.formLabel}>{t("relatedAchievement")}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Autocomplete
            sx={commonStyles.autocompleteStyles}
            ListboxProps={{
              sx: { width: "393px" },
            }}
            options={achievementsList.map((achievement) => achievement.id) || []}
            value={value}
            onChange={(_, newValue) => onChange(newValue)}
            getOptionLabel={(option) => achievementsList.find((achievement) => achievement.id === option)?.name || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={commonStyles.textField}
                placeholder={value ? undefined : t("selectAchievement")}
                error={!!error}
              />
            )}
            popupIcon={<CreatePostAutocompleteIcon />}
          />
        )}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};
